// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3eJbN","additionalInfo":"AgreementModal_additionalInfo__1pcUJ"};